import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { createAsyncThunkSafe } from '@/state/_base/createAsyncThunkSafe';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { RequestWorkspaceUserInvitationCreate } from '@shared/dto/+workspace/workspace_user_invitation/_requests/request_workspace_user_invitation_create';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { STATE__workspace } from '../STATE__workspace';

export const remote_workspace_user_invitation_create = createAsyncThunkSafe<void, RequestWorkspaceUserInvitationCreate>(
  ENUM__network_event_client_to_server.WORKSPACE_USER_INVITATION_CREATE,
  async (request: RequestWorkspaceUserInvitationCreate): Promise<void> => {
    await send_to_server(ENUM__network_event_client_to_server.WORKSPACE_USER_INVITATION_CREATE, request);
  },
);

export function init_remote_workspace_user_invitation_create(builder: ActionReducerMapBuilder<STATE__workspace>) {
  builder
    .addCase(remote_workspace_user_invitation_create.pending, (state, action) => {})
    .addCase(remote_workspace_user_invitation_create.rejected, (state, action) => {})
    .addCase(remote_workspace_user_invitation_create.fulfilled, (state, action: PayloadAction) => {});
}
